import cn from 'classnames';

import useTooltip from 'js/hooks/use-tooltip';

import Tooltip from 'components/tooltip/Tooltip';

import { IGroupedSearchPageSectionFilterList } from 'source/NFR.types';

interface GroupedSearchPageSectionFilterListProps extends IGroupedSearchPageSectionFilterList {
  fetchResultsWithSection: (name: string, value: string | undefined) => void;
  hasLowerCaseSectionFilters?: boolean;
}

const GroupedSearchPageSectionFilterList: React.FC<GroupedSearchPageSectionFilterListProps> = ({
  fetchResultsWithSection,
  list,
  hasLowerCaseSectionFilters
}) => {
  const { ref, handleMouseEnter, handleMouseLeave, showTabTooltip, showTooltip } = useTooltip();

  return (
    <>
      {list && (
        <ul className="grouped-search-page-section-filter-list">
          {list.map(({ isCurrent, label, value, name, isDisabled, tooltip }) => (
            <li
              className="grouped-search-page-section-filter-list__item"
              {...(tooltip
                ? {
                    ref: ref as React.RefObject<HTMLLIElement>,
                    onMouseEnter: handleMouseEnter,
                    onMouseLeave: handleMouseLeave
                  }
                : {})}
              key={label}
            >
              <button
                className={cn('grouped-search-page-section-filter-list__button', {
                  'grouped-search-page-section-filter-list__button--is-current': isCurrent,
                  'grouped-search-page-section-filter-list__button--lower-case': hasLowerCaseSectionFilters
                })}
                onClick={() => fetchResultsWithSection(name, !isCurrent ? value : undefined)}
                disabled={isDisabled}
                type="button"
              >
                <span>{label}</span>
              </button>
              {tooltip && (showTabTooltip || showTooltip) && <Tooltip useTabStyle={showTabTooltip}>{tooltip}</Tooltip>}
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

GroupedSearchPageSectionFilterList.displayName = 'GroupedSearchPageSectionFilterList';

export default GroupedSearchPageSectionFilterList;
